<template>
  <nav>
    <v-toolbar flat app class="primary">
      <v-toolbar-side-icon class="white--text" @click="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title class="text-uppercase white--text">
        <span class="font-weight-white">Store</span>
        <span>manager</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-navigation-drawer v-model="drawer" stateless app class="dark">
      <v-layout column align-center>
        <v-flex class="mt-5">
          <v-avatar size="100">
            <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="alt">
          </v-avatar>
          <p class="white--text subheading mt-2">Lilahamstern</p>
        </v-flex>
      </v-layout>
      <v-list>
        <v-list-tile v-for="link in links" :key="link.text" router :to="link.route">
          <v-list-tile-action>
            <v-icon class="white--text">{{link.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">{{link.text}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      drawer: true,
      links: [
        { icon: "dashboard", text: "Dashboard", route: "/dashboard" },
        { icon: "store", text: "Stores", route: "/stores" },
        { icon: "settings", text: "Settings", route: "/team" },
        { icon: "exit_to_app", text: "Sign out", route: "/logout" }
      ]
    };
  }
};
</script>
